import { useMemo } from 'preact/hooks'
import { checkConditions } from '@/components/helpers/metaobjects'
import { globalState } from '@/components/helpers/utils'
import { Criteria } from '@/components/helpers/metaobjects.types'

/**
 * Takes a criteria object to pass to checkConditions to validate what ranges should display.
 */

export function useRanges(criteria: Criteria) {
  return useMemo(() => {
    const data = globalState.metaobjects.ranges
    return data
      .filter((range) => checkConditions(range, criteria))
      .sort((a, b) => a.priority - b.priority)
  }, [criteria])
}
